/* ================================================================
   LegBilligt — Pakkeleg-maskinen + Skattekisten
   Henter varer fra en kollektion og leger med dem.
   Ingen MutationObserver. Alt hentes forst nar sektionen ses.

   HENTER FRA ?view=eget, IKKE products.json (18. september 2026).
   To grunde:
   1. products.json indeholder ikke template_suffix, og fjernlager-
      maerket ER template_suffix "fjernlager". Tag-kontrakten forbyder
      et tag for fjernlager, fordi det saa skal holdes synkront to
      steder. JS'en kunne derfor ikke se forskel, og Skattekisten
      viste leverandoervarer. Nu filtrerer serveren.
   2. products.json svarer i kollektionens egen sortering. Alle
      kollektioner er sorteret BEST_SELLING, og butikken har 0 ordrer
      i Shopify, saa den sortering lagde de udsolgte forrest: side 1
      af /collections/legetoej havde 0 koebbare varer ud af 250.
      ?view=eget filtrerer paa available paa serveren.

   Og vi gaetter ikke laengere paa antallet af sider: svaret indeholder
   "sider", saa de tilfaeldige sider traekkes i hele kollektionen og
   ikke kun i toppen. Det var derfor Skattekisten kun viste
   modelbyggesaet - ét-styks-varerne klumper sig sammen i toppen.

   OG SAA SPREDES KORTENE (18-09). Selv med hele kollektionen i
   puljen er restsalget tungt paa modelbyg - 31 % af en stikproeve
   paa 642 varer - saa en blanding alene gav stadig fire modelsaet
   ud af ni kort. spred() i bunken() tager nu ét kort fra hver
   varegruppe paa skiftende tur i stedet.
   ================================================================ */
(function(){
  'use strict';

  var puljer  = {};     // handle -> array of varer
  var henter  = {};     // handle -> Promise
  var hentede = {};     // handle -> {sidenr: 1} — hvilke sider vi HAR set
  var komplet = {};     // handle -> true naar hele kollektionen er hentet
  var sideAntal = {};   // handle -> antal sider, som ?view=eget melder

  function kr(n){
    return n.toFixed(2).replace('.', ',') + ' kr';
  }

  /* ?view=eget leverer billedet med en bredde paa (width=640), hvor
     products.json leverede det uden. Saetter vi bare endnu et width=
     paa, staar der to i samme adresse, og de sma kort fik 640 i
     stedet for 500. Derfor rettes den der er, og ellers saettes en. */
  function lille(src, bredde){
    if(!src) return '';
    if(/[?&]width=\d+/.test(src)) return src.replace(/([?&]width=)\d+/, '$1' + bredde);
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + bredde;
  }

  /* Varegruppen ligger i varens k2-tag (k2-modelbyggesaet, k2-baby,
     k2-dukker ...). Findes der ikke et, bruges k1. Bruges KUN til at
     sprede Skattekistens kort ud - aldrig til at sortere varer fra. */
  function gruppeAf(p){
    var t = p.tags || [], i, k1 = '';
    for(i = 0; i < t.length; i++){
      if(String(t[i]).indexOf('k2-') === 0) return t[i];
      if(!k1 && String(t[i]).indexOf('k1-') === 0) k1 = t[i];
    }
    return k1 || '(andet)';
  }

  function normaliser(p){
    var v = null, i;
    for(i = 0; i < p.variants.length; i++){
      if(p.variants[i].available){ v = p.variants[i]; break; }
    }
    if(!v) return null;
    var pris = parseFloat(v.price);
    if(!(pris > 0)) return null;
    var raa = (p.images && p.images[0]) ? p.images[0].src : '';
    return {
      id: v.id,
      titel: p.title,
      url: '/products/' + p.handle,
      pris: pris,
      lager: (typeof v.inventory_quantity === 'number') ? v.inventory_quantity : null,
      gruppe: gruppeAf(p),
      bil: lille(raa, 500),      // sma kort
      stor: lille(raa, 640)      // skattekistens kort
    };
  }

  /* Billeder: vis skelet, ton billedet ind nar det er hentet */
  function tonInd(rod){
    function faerdig(im){
      im.classList.add('klar');
      if(im.parentNode && im.parentNode.classList) im.parentNode.classList.add('klar');
    }
    rod.querySelectorAll('.im img').forEach(function(im){
      if(im.complete && im.naturalWidth > 0){ faerdig(im); return; }
      im.addEventListener('load', function(){ faerdig(im); });
      im.addEventListener('error', function(){ faerdig(im); });
    });
  }

  /* Hjerte til onskesedlen pa de kort vi selv bygger */
  function hjerter(){
    if(window.lbKortHjerter) window.lbKortHjerter();
  }

  function forhent(url){
    if(!url) return;
    var i = new Image();
    i.decoding = 'async';
    i.src = url;
  }

  function hentSide(handle, nr){
    /* -1 = siden har vi allerede. 0 = siden findes ikke. >0 = antal varer.
       De to foerste MAA ikke forveksles: hvis "allerede hentet" svarede 0,
       ville heleLageret tro at kollektionen slap op ved foerste kendte side. */
    if(hentede[handle] && hentede[handle][nr]) return Promise.resolve(-1);
    if(!hentede[handle]) hentede[handle] = {};
    hentede[handle][nr] = 1;
    /* filter.v.availability=1 er IKKE til pynt. ?view=eget filtrerer paa
       available, men Liquid filtrerer FOERST efter sideopdelingen, saa en
       side, hvor alt er udsolgt, kommer tilbage helt tom: side 1 af
       /collections/legetoej gav 0 varer ud af 250. Med Shopifys eget
       availability-filter sker udvalget FOER sideopdelingen, og saa er
       hver side fuld: samme side gav 50 varer og 38 sider i alt. */
    return fetch('/collections/' + handle + '?view=eget&filter.v.availability=1&page=' + nr)
      .then(function(r){ return r.ok ? r.json() : {products:[]}; })
      .catch(function(){ return {products:[]}; })
      .then(function(d){
        var liste = d.products || [], i, n;
        if(d.sider) sideAntal[handle] = d.sider;
        if(!puljer[handle]) puljer[handle] = [];
        for(i = 0; i < liste.length; i++){
          n = normaliser(liste[i]);
          if(n) puljer[handle].push(n);
        }
        return liste.length;          // 0 = siden findes ikke
      });
  }

  /* Foerste side hentes ALTID foerst: den er den eneste, der fortaeller
     hvor mange sider kollektionen har. Foerst naar vi ved det, kan de
     tilfaeldige sider traekkes i hele kollektionen. Gjorde vi som foer -
     gaettede paa 4-6 sider - ramte vi kun toppen af BEST_SELLING, hvor
     de samme varegrupper klumper sig sammen.
     Delt pulje pr. handle, saa Pakkeleg og Skattekisten paa samme side
     ikke henter det samme to gange. */
  function hentBredt(handle, ekstraSider){
    if(komplet[handle]) return Promise.resolve(puljer[handle] || []);
    if(henter[handle]) return henter[handle];

    henter[handle] = hentSide(handle, 1).then(function(){
      var sider = sideAntal[handle] || 1;
      if(sider <= 1) return puljer[handle] || [];
      var valgt = {}, kald = [], i, n, forsog = ekstraSider * 4;
      for(i = 0; i < forsog && kald.length < ekstraSider && kald.length < sider - 1; i++){
        n = 2 + Math.floor(Math.random() * (sider - 1));
        if(valgt[n]) continue;
        valgt[n] = 1;
        kald.push(hentSide(handle, n));
      }
      return Promise.all(kald).then(function(){ return puljer[handle] || []; });
    });
    return henter[handle];
  }

  /* ---- hele lageret --------------------------------------------
     Den hurtige pulje er to tilfaeldige sider. Det er rigeligt til at
     finde tre ting for 200 kr, men IKKE nok til at sige nej: de tre
     billigste varer i kollektionen ligger maaske paa en side vi ikke
     har hentet. Derfor henter vi resten FOER vi svarer "kan ikke lade
     sig goere". Vi stopper ved foerste tomme side, saa der er ingen
     sidetal at vedligeholde naar sortimentet vokser.
     Sekventielt og ikke parallelt: det sker sjaeldent, og en byge af
     seks samtidige products.json-kald ville koste mere end den ene
     ekstra ventetid. ------------------------------------------- */
  function heleLageret(handle){
    if(komplet[handle]) return Promise.resolve(puljer[handle] || []);
    function naeste(nr){
      /* Sideantallet kommer fra svaret. Kender vi det ikke endnu, stopper
         vi ved 80 sider a 50 varer - rigeligt til hele butikken. */
      var MAKS = sideAntal[handle] || 80;
      if(nr > MAKS){ komplet[handle] = true; return puljer[handle] || []; }
      return hentSide(handle, nr).then(function(antal){
        if(antal === 0){                   // siden findes ikke — vi er igennem
          komplet[handle] = true;
          return puljer[handle] || [];
        }
        return naeste(nr + 1);
      });
    }
    return Promise.resolve(naeste(1));
  }

  /* toSider() og tilfaeldigSide() er fjernet 18-09-2026. De gaettede paa
     et sideantal (4 og 6), og med 50 varer pr. side ramte de kun de
     foerste 200-300 varer i en kollektion paa flere tusinde. hentBredt()
     laeser det rigtige sideantal fra svaret i stedet. */

  /* Hent kurv-ikonet forfra — add.js svarer nogle gange med den gamle kurv */
  function opdaterKurvIkon(){
    var boble = document.getElementById('cart-icon-bubble');
    if(!boble) return;
    fetch('/?sections=cart-icon-bubble')
      .then(function(r){ return r.json(); })
      .then(function(d){
        if(!d || !d['cart-icon-bubble']) return;
        var midl = document.createElement('div');
        midl.innerHTML = d['cart-icon-bubble'];
        var nyt = midl.querySelector('#cart-icon-bubble');
        boble.innerHTML = nyt ? nyt.innerHTML : d['cart-icon-bubble'];
      })
      .catch(function(){});
  }

  function laegIKurv(varer, knap, faerdig){
    var poster = varer.map(function(v){ return { id: v.id, quantity: 1 }; });
    var oprindelig = knap ? knap.textContent : '';
    if(knap){ knap.disabled = true; knap.textContent = 'Lægger i kurv …'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: poster })
    })
    .then(function(r){ return r.json(); })
    .then(function(){
      opdaterKurvIkon();
      if(knap){ knap.textContent = 'Lagt i kurven'; knap.classList.add('ok'); }
      setTimeout(function(){
        if(knap){ knap.disabled = false; knap.textContent = oprindelig; knap.classList.remove('ok'); }
        if(faerdig) faerdig();
      }, 900);
    })
    .catch(function(){
      if(knap){ knap.disabled = false; knap.textContent = 'Prøv igen'; }
    });
  }

  /* ============================================================
     1. PAKKELEG-MASKINEN
     Reglen: summen ma ALDRIG overstige belobet.
     Naeste forslag regnes ud og forhentes med det samme,
     sa "Find tre andre" kommer uden ventetid pa billeder.
     ============================================================ */
  function pakkeleg(rod){
    var kilde = rod.getAttribute('data-kilde') || 'restsalg';
    var felt  = rod.querySelector('.lbpk-tal');
    var res   = rod.querySelector('.lbpk-res');
    var goKn  = rod.querySelector('.lbpk-go');
    var klar  = false;
    var forud = null, forudMaal = null;

    rod.querySelectorAll('.lbpk-hurtig').forEach(function(b){
      b.addEventListener('click', function(){
        felt.value = b.getAttribute('data-belob');
        find();
      });
    });
    goKn.addEventListener('click', find);
    felt.addEventListener('keydown', function(e){ if(e.key === 'Enter'){ e.preventDefault(); find(); } });

    function find(){
      var maal = parseInt(felt.value, 10);
      if(!(maal > 0)){ maal = 200; felt.value = 200; }
      if(!klar) res.innerHTML = '<p class="lbpk-vent">Finder tre ting …</p>';
      var hent = klar ? Promise.resolve(puljer[kilde] || []) : hentBredt(kilde, 2);
      hent.then(function(pulje){
        klar = true;
        var tre = tag(pulje, maal);
        if(tre){ vis(tre, maal); return; }

        /* Vi fandt ikke noget i den hurtige pulje. Det er IKKE et nej:
           vi har kun set to sider af kollektionen. Foer vi svarer, kigger
           vi hele lageret igennem. Sker kun ved stramme belob. */
        res.innerHTML = '<p class="lbpk-vent">Kigger hele lageret igennem …</p>';
        heleLageret(kilde).then(function(alt){
          forud = null; forudMaal = null;
          vis(tag(alt, maal), maal);
        });
      });
    }

    function tag(pulje, maal){
      var t = (forud && forudMaal === maal) ? forud : vaelgTre(pulje, maal);
      forudMaal = maal;
      forud = vaelgTre(pulje, maal);
      if(forud) forud.forEach(function(v){ forhent(v.bil); });
      return t;
    }

    /* Summen af de tre billigste varer i puljen. Det er GULVET: kan
       de tre ikke holde sig inden for belobet, findes der ingen
       losning, og saa er et nej sandt. */
    function gulvet(pulje){
      if(!pulje || pulje.length < 3) return null;
      var s = pulje.slice(0).sort(function(a, b){ return a.pris - b.pris; });
      return s[0].pris + s[1].pris + s[2].pris;
    }

    /* PROEVET OG KASSERET: kun tilfaeldig udtraekning af tre varer
       2.500 gange. Ved et stramt belob er den gyldige kombination saa
       sjaelden i puljen, at 2.500 forsog stort set aldrig rammer den —
       maskinen svarede "kan ikke lade sig goere" selv om tre varer til
       10 kr laa lige der. Loesningen er ikke flere forsoeg, men et
       GARANTERET udgangspunkt: de tre billigste. Passer de, har vi
       allerede et gyldigt svar, og udtraekningen skal kun bruges til
       at komme taettere paa belobet. */
    function vaelgTre(pulje, maal){
      var loft = maal + 0.001;
      var muligt = pulje.filter(function(v){ return v.pris < loft; });
      if(muligt.length < 3) return null;

      var billigst = muligt.slice(0).sort(function(a, b){ return a.pris - b.pris; });
      var gulv = billigst[0].pris + billigst[1].pris + billigst[2].pris;
      if(gulv > loft) return null;              // aegte umuligt

      var bedst = [billigst[0], billigst[1], billigst[2]];
      var bedstSum = gulv, i, a, b, c, sum;
      for(i = 0; i < 2500; i++){
        a = muligt[Math.floor(Math.random() * muligt.length)];
        b = muligt[Math.floor(Math.random() * muligt.length)];
        c = muligt[Math.floor(Math.random() * muligt.length)];
        if(a.id === b.id || b.id === c.id || a.id === c.id) continue;
        sum = a.pris + b.pris + c.pris;
        if(sum > loft) continue;                 // ma aldrig ga over
        if(sum > bedstSum){ bedstSum = sum; bedst = [a, b, c]; }
        if(maal - sum < 2) break;                // taet nok pa
      }
      return bedst;
    }

    function vis(tre, maal){
      if(!tre){
        /* Sig hvad der ER muligt i stedet for bare at sige nej. Naar vi
           naar hertil, har vi hele kollektionen, saa gulvet er et tal vi
           kan staa inde for. */
        var gulv = gulvet(puljer[kilde]);
        if(gulv){
          res.innerHTML = '<p class="lbpk-vent">Tre ting kan ikke blive billigere end ' +
            kr(gulv) + ' hos os lige nu. Prøv det beløb — eller et højere.</p>';
        } else {
          res.innerHTML = '<p class="lbpk-vent">Vi kunne ikke finde tre ting, der holder sig under ' + maal + ' kr. Prøv et højere beløb.</p>';
        }
        return;
      }
      var sum = tre[0].pris + tre[1].pris + tre[2].pris;
      var h = '<div class="lbpk-tre">';
      tre.forEach(function(v){
        h += '<a class="lbpk-k" href="' + v.url + '">' +
               '<span class="im"><img src="' + v.bil + '" alt="" decoding="async"></span>' +
               '<h4>' + v.titel + '</h4>' +
               '<div class="pr">' + kr(v.pris) + '</div>' +
             '</a>';
      });
      h += '</div>';
      h += '<div class="lbpk-bund">' +
             '<div class="lbpk-sum"><span>I alt</span><b>' + kr(sum) + '</b></div>' +
             '<button type="button" class="lbpk-add">Læg alle tre i kurven</button>' +
             '<button type="button" class="lbpk-igen">Find tre andre</button>' +
           '</div>';
      res.innerHTML = h;
      tonInd(res);
      hjerter();
      res.querySelector('.lbpk-add').addEventListener('click', function(){
        laegIKurv(tre, this);
      });
      res.querySelector('.lbpk-igen').addEventListener('click', find);
    }

    return find;
  }

  /* ============================================================
     2. SKATTEKISTEN — ja tak eller naeste
     ============================================================ */
  function bunken(rod){
    var kilde = rod.getAttribute('data-kilde') || 'sidste-stykke';
    var scene = rod.querySelector('.lbbu-scene');
    var jaKn  = rod.querySelector('.lbbu-ja');
    var nejKn = rod.querySelector('.lbbu-nej');
    var pulje = [], plads = 0;

    scene.innerHTML = '<div class="lbbu-vent">Kigger i kisten …</div>';

    hentBredt(kilde, 3).then(function(p){
      pulje = spred(p.slice(0));
      if(!pulje.length){ scene.innerHTML = '<div class="lbbu-vent">Kisten er tom lige nu.</div>'; return; }
      tegn();
    });

    function bland(a){
      for(var i = a.length - 1; i > 0; i--){
        var j = Math.floor(Math.random() * (i + 1));
        var t = a[i]; a[i] = a[j]; a[j] = t;
      }
      return a;
    }

    /* SPRED KORTENE UD OVER VAREGRUPPER - ikke bare bland dem.
       Restsalget er ikke jaevnt fordelt. Stikproeve 18-09 paa 642
       varer (14 af 54 sider i "restsalg"): 31 % modelbygning, og
       alene k2-modelbyggesaet 20 %. Det er ikke en fejl i data - et
       modelsaet koebes som ét stykke, saa det ender naturligt med
       1-3 tilbage. Men en almindelig blanding gav derfor fire
       Tamiya-saet ud af ni kort, og Jakob saa en kiste der "kun
       viser modelbyg".

       Derfor: varerne deles i grupper efter k2-tagget (31 grupper i
       restsalget), hver gruppe blandes, gruppernes tur blandes, og
       saa tages ét kort fra hver gruppe paa skiftende tur. Saa
       laenge der er mere end én gruppe tilbage, kommer to kort i
       traek ALDRIG fra samme gruppe.

       Ingen varer sorteres fra - hele puljen er stadig med, kun
       raekkefoelgen er aendret. Det er vigtigt: kisten skal vise alt
       vi har 1-3 stk. af, ikke et udvalg. */
    function spred(a){
      var grupper = {}, noegler = [], i, k;
      for(i = 0; i < a.length; i++){
        k = a[i].gruppe || '(andet)';
        if(!grupper[k]){ grupper[k] = []; noegler.push(k); }
        grupper[k].push(a[i]);
      }
      for(i = 0; i < noegler.length; i++){ bland(grupper[noegler[i]]); }
      bland(noegler);
      var ud = [], tilbage = a.length, liste;
      while(tilbage > 0){
        for(i = 0; i < noegler.length; i++){
          liste = grupper[noegler[i]];
          if(liste.length){ ud.push(liste.pop()); tilbage--; }
        }
      }
      return ud;
    }

    function nu(){ return pulje[plads % pulje.length]; }

    function tegn(){
      var v = nu();
      scene.innerHTML =
        '<div class="lbbu-kort">' +
          '<a class="im" href="' + v.url + '"><img src="' + v.stor + '" alt="" decoding="async"></a>' +
          '<div class="bd">' +
            '<span class="lbbu-bg">' + (v.lager > 1 ? v.lager + ' TILBAGE' : 'KUN 1 TILBAGE') + '</span>' +
            '<h4><a href="' + v.url + '">' + v.titel + '</a></h4>' +
            '<div class="pr">' + kr(v.pris) + '</div>' +
          '</div>' +
        '</div>';
      tonInd(scene);
      hjerter();
      /* forhent de to naeste kort */
      for(var n = 1; n <= 2; n++){
        var k = pulje[(plads + n) % pulje.length];
        if(k) forhent(k.stor);
      }
      swipe(scene.querySelector('.lbbu-kort'));
    }

    function naeste(retning){
      var kort = scene.querySelector('.lbbu-kort');
      if(kort){
        kort.style.transition = 'transform .22s ease, opacity .22s ease';
        kort.style.transform = 'translateX(' + (retning * 420) + 'px) rotate(' + (retning * 9) + 'deg)';
        kort.style.opacity = '0';
      }
      plads++;
      setTimeout(tegn, 190);
    }

    nejKn.addEventListener('click', function(){ naeste(-1); });
    jaKn.addEventListener('click', function(){
      var v = nu();
      laegIKurv([v], jaKn, function(){ naeste(1); });
    });

    function swipe(kort){
      if(!kort) return;
      var x0 = null, dx = 0;
      kort.addEventListener('touchstart', function(e){
        x0 = e.touches[0].clientX; dx = 0;
        kort.style.transition = 'none';
      }, {passive:true});
      kort.addEventListener('touchmove', function(e){
        if(x0 === null) return;
        dx = e.touches[0].clientX - x0;
        kort.style.transform = 'translateX(' + dx + 'px) rotate(' + (dx / 26) + 'deg)';
      }, {passive:true});
      kort.addEventListener('touchend', function(){
        if(x0 === null) return;
        if(Math.abs(dx) > 90){
          if(dx > 0){ var v = nu(); laegIKurv([v], jaKn, function(){ naeste(1); }); }
          else { naeste(-1); }
        } else {
          kort.style.transition = 'transform .18s ease';
          kort.style.transform = '';
        }
        x0 = null;
      });
    }
  }

  /* ============================================================
     Start — forst nar sektionen naermer sig skaermen
     ============================================================ */
  function naerSkaerm(el, kald){
    if(!('IntersectionObserver' in window)){ kald(); return; }
    var io = new IntersectionObserver(function(poster){
      poster.forEach(function(p){
        if(p.isIntersecting){ io.disconnect(); kald(); }
      });
    }, { rootMargin: '600px 0px' });
    io.observe(el);
  }

  function start(){
    document.querySelectorAll('.lbpk').forEach(function(el){
      if(el.dataset.klar) return; el.dataset.klar = '1';
      var find = pakkeleg(el);
      naerSkaerm(el, find);
    });
    document.querySelectorAll('.lbbu').forEach(function(el){
      if(el.dataset.klar) return; el.dataset.klar = '1';
      naerSkaerm(el, function(){ bunken(el); });
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();